<template>
  <b-container id="bcon"  fluid>
       <img v-if="showloading == true" src="../assets/245.gif" style="z-index: 999;position: fixed; top: 15px;left: 40%;" />
    <b-row>
      <b-col cols="12">

      <table><tr><td>

       <table>
        <tr><td>hi:&nbsp;{{user}}</td><td><a href="#" v-on:click.prevent="logout">log out</a></td>
        <td> 
         <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')">Notifications</b-button>
     </td>
        </tr>
        <tr><td> <input type="text" v-model="newOrg" placeholder="Enter Organization" >
       </td><td><b-button @click="submitOrg" variant="outline-dark" >Add</b-button> </td>
       </tr></table>

        </td></tr>
        <tr><td>

          <table><tr>
          <td>                  
            <ul id="orgspan" v-for="(docs, index) in this.orgArray" :key="docs.id" >
                   <li id="osspan"
                   :class="{ active : active_el == index }"
                    @click.prevent="changeOrg(docs.name);activate(index);" > {{docs.name}} <router-link v-if="docs.role == 'owner'" v-bind:to="'/Organization/'+docs.id">edit</router-link>
                    </li>
            </ul>
            
            </td>
          <td></td>
            <td>
              
            </td>
          </tr></table>

          </td></tr></table>  
        
      </b-col>      
    </b-row>
    <b-row >
      <b-col id="departmentcols"  cols="3" v-if="this.isTrue1 == true">
         <table><tr><td>
          <table><tr><td>
            <form id="createdepartmentform" @submit.prevent="insertDepartment">
           <b-form-input v-model="text" placeholder="Enter Department" style="position: relative; float: left;width: 70%;"></b-form-input>
        
             <b-button type="submit" variant="outline-dark" style="position: relative; float: right;">Submit</b-button>

             </form>
            </td></tr></table>
            </td></tr>
            <tr><td>
              <span id="dstyle">Departments</span>
              </td></tr>
              <tr><td>
                <br>
                <div id="deptdiv">

                  <span style="width: 100%;" v-for="docs in this.departments" :key="docs.name" >
                   <span id="wholedept" @click="setDept(docs.name)"> <span id="deptx">x</span>{{docs.name}} </span><br><br>
                  </span>
                </div>
                </td></tr>
            </table>
      </b-col>
           
      <b-col cols="9" v-if="this.isTrue2 == true">

         <table id="step2"><tr><td>
               <table><tr><td>

            <form id="addWorkerForm" @submit.prevent="addWorker">
            
            <!-- <label for="deptid">Choose Image</label> -->
            <input type="file" style="width: 22%;"  name="deptid" id="deptid" accept="image/*" @change="getImage" >
            <input type="text" style="width: 20%;" v-model="WData.fullname" placeholder="Full Name" >
            <label for="issueddate">Issue Date</label>
               <input type="date" id="issueddate" v-model="WData.issueddate" class="mb-2">
               <label for="expirydate">Expiry Date</label>
               <input type="date" id="expirydate" v-model="WData.expirydate" class="mb-2">
               <!--</b-form-datepicker>-->
             <b-button type="submit" variant="outline-dark" style="position: relative; float: right;">Submit</b-button>

             </form>
            </td></tr></table>

            </td></tr>
              <tr><td>
                <br>
                <div id="deptWorkers">

                    
                  <span style="width: 100%;" v-for="docs in this.curdeptWorkers" :key="docs.id" >
                   <span id="" > {{docs.name}} </span>:  http://id-verifier-41bb8.web.app/userProfile/{{docs.id}} : <router-link v-bind:to="'/UserProfile/'+docs.id">Click Link</router-link><qr-code id="qrcodeholder" v-bind:text="'http://id-verifier-41bb8.web.app/userProfile/'+docs.id"></qr-code><br><br>
                  </span>

                </div>
                </td></tr>
            </table>

      </b-col>
      
    </b-row>

       <b-modal id="bv-modal-example" hide-footer>
    <template #modal-title>
      
    </template>
    <div class="d-block text-center">
     
      <span style="width: 100%;" v-for="docs in this.notifications" :key="docs.id" >
        <span v-if="docs.type == 'admin'">
          {{docs.requester}}&nbsp; has invited you as ADMIN of Organization &nbsp; {{docs.orgname}}.<br>
          <table><tr><td>
            <b-button variant="success" @click="accept(docs.notifid,docs.id,docs.orgname,docs.type)" v-if="docs.accepted == 'no'">Accept</b-button>

            <span v-if="docs.accepted == 'accepted'">Accepted</span>

            </td><td>
            <b-button variant="outline-dark"  @click="reject(docs.notifid)" v-if="docs.rejected == 'no'">Reject</b-button>
           
            <span v-if="docs.rejected == 'rejected'">rejected</span>
            </td>
            </tr></table>

        </span>

        <!-- v-if owner ----------------------------------------------------------------------------------------------->

          <span v-if="docs.type == 'owner'">
          {{docs.requester}}&nbsp; has invited you as OWNER of Organization &nbsp; {{docs.orgname}}.<br>
          <table><tr><td>
            <b-button variant="success" @click="acceptowner(docs.notifid,docs.id,docs.orgname)" v-if="docs.accepted == 'no'">Accept</b-button>

            <span v-if="docs.accepted == 'accepted'">Accepted</span>

            </td><td>
            <b-button variant="outline-dark"  @click="reject(docs.notifid)" v-if="docs.rejected == 'no'">Reject</b-button>
           
            <span v-if="docs.rejected == 'rejected'">rejected</span>
            </td>
            </tr></table>

        </span>
          
      </span>

    </div>
    <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example');getOrgs;">Close</b-button>
  </b-modal>
  </b-container>
  
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'dashboard',
  data (){
    return {
      //user: this.$store.getUser.username,
      text: "",
      showloading: false,
      notifications: null,
      isTrue1: false,
      isTrue2: false,
       active_el: null,
      departments: null,
      imageData: null,
      WData:{
        imagepath: "",
        fullname: "",
        issueddate: "",
        expirydate: "",
        curdept: "testdept1",
        imageName: ""
      },
      newOrg: "",
      curdeptWorkers: null,
      uploadValue: 0,
      uploadValuet: 0,
      curOrg: "",
      orgArray: [{name:'testOrg1',id:'fdffdfd645gf'},{name:'testOrg2',id:'s8d76ffsdds765s'},{name:'testOrg3',id:'sd65s865fd6sd8s87'}]
    }
  },
  methods:{
    acceptowner:function(value,value2,value3){
               this.showloading = true;
      var postid = value;
      var orgid = value2;
      var orgname = value3;
      var count = 0;
     
  firebase.firestore().collection("User.Organizations").where("orgname", "==", orgname).get().then(snap => {

      snap.forEach(doc => {
        var id = doc.id;
        var docuser = doc.data().username;
      if(this.user == docuser){
        firebase.firestore().collection("User.Organizations").doc(id).update(
              {
                role: "owner"
              })
              count++;
              console.log("owner updated");
      }else{
        firebase.firestore().collection("User.Organizations").doc(id).update(
              {
                role: "admin"
              })
              console.log("admin updated");
      }
      })
    }).then(()=>{

      if(count == 0){

              firebase.firestore().collection("User.Organizations").add(
              {
                username: this.user,
                orgname: orgname,
                role: "owner",
                orgid: orgid
              }
            )
             console.log("owner created");
      }

    })



       firebase.firestore().collection("Notifications").doc(postid).update({
                accepted: "accepted",
                rejected: "accepted"
                }).then(()=>{

              firebase.firestore().collection("Organizations").doc(orgid).update(
              {
                owner: this.user
              })


                }).then(()=>{

              const user = firebase.auth().currentUser;

              console.log("user object",user);

                  firebase.firestore().collection("Notifications").where("requesteeEmail", "==", user.email).get().then(snap => {
                let orgs = [];
                snap.forEach(doc => {
                  orgs.push({id: doc.data().orgid,notifid: doc.id,type: doc.data().type,accepted:doc.data().accepted,rejected:doc.data().rejected,requestee:doc.data().requestee,requester:doc.data().requester,requesterEmail:doc.data().requesterEmail,orgname:doc.data().orgname})
                  this.notifications = orgs;
                  console.log(this.notifications);
                })
              })
                
                this.showloading = false;
                })

    
          },
         activate:function(el){
          this.active_el = el;
          if(this.isTrue1 == false){
            this.isTrue1 = true;
          }
          },
        changeOrg: function(value){
          this.showloading = true;
          this.curOrg = value;
          console.log(this.curOrg);
          this.departments = null;
            firebase.firestore().collection("Departments").where("username", "==", this.user).where("orgname", "==", this.curOrg).get().then(snap => {
      let depts = [];
      snap.forEach(doc => {
        depts.push({name: doc.data().deptname})
        this.departments = depts;
         this.showloading = false;
      })
    })
        this.showloading = false

        },
        submitOrg: function(){
          if(this.newOrg != "" ){
            firebase.firestore().collection("Organizations").add(
              {
                owner: this.user,
                name: this.newOrg,
                address: "",
                logo: ""
              }
            ).then((ref)=>{

                console.log(ref.id)
              firebase.firestore().collection("User.Organizations").add(
              {
                username: this.user,
                orgname: this.newOrg,
                role: "owner",
                orgid: ref.id
              }
            ).then(()=>{
              this.newOrg = "";
            }).catch(error => {
              console.log(error.message)
            })

            }).catch(error => {
              console.log(error.message)
            })

          }

        },
    insertDepartment: function(){
      this.showloading = true;
      this.departments = null;
      firebase.firestore().collection("Departments").add(
        {
          username: this.user,
          deptname: this.text,
          orgname: this.curOrg
        }).then(()=>{
                      firebase.firestore().collection("Departments").where("orgname", "==", this.curOrg).get().then(snap => {
      let depts = [];
      snap.forEach(doc => {
        depts.push({name: doc.data().deptname})
        this.departments = depts;
        console.log("2")
      })
                      })
                       this.showloading = false
        })

        this.text = "";
    },
    getImage(event){
      this.imageData = event.target.files[0];
      console.log(this.imageData);
    },
    setDept: function(foo){
      this.WData.curdept = foo;
      if(this.isTrue2 == false){
            this.isTrue2 = true;
          }
      console.log(this.WData.curdept);

            firebase.firestore().collection("Departmentdata").where("curdept", "==", this.WData.curdept).get().then(snap => {
      let deptWs = [];
      snap.forEach(doc => {
        deptWs.push({id: doc.id,name: doc.data().fullname,curdept:doc.data().curdept,qrcode:doc.data().qrcodeurl})
        this.curdeptWorkers = deptWs;
         console.log("3")
        console.log(deptWs);
      })
    })
     
    },
    addWorker: function(){
        this.showloading = true;
    if(this.WData.fullname !== '' && this.WData.curdept !== '' && this.WData.issueddate !== '' && this.WData.expirydate !== "" ){
    
        this.WData.imageName = this.imageData.name;
      const storageRef=firebase.storage().ref(`${this.imageData.name}`).put(this.imageData);
      
      storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{

          this.WData.imagepath = url;
        
          firebase.firestore().collection("Departmentdata").add(this.WData).then(()=>{
          

      firebase.firestore().collection("Departmentdata").where("curdept", "==", this.WData.curdept).get().then(snap => {
      let deptWs = [];
      snap.forEach(doc => {
        deptWs.push({id: doc.id,name: doc.data().fullname,curdept:doc.data().curdept,qrcode:doc.data().qrcodeurl})
        this.curdeptWorkers = deptWs;
         console.log("3")
        console.log(deptWs);
      })
    })

    this.showloading = false;
       

          })
              
        });
      }
      );
        document.getElementById('addWorkerForm').reset();
      }else{
        alert("Enter a value for each field");
      }
    },
    accept:function(value,value2,value3,value4){
      var postid = value;
      var orgid = value2;
      var orgname = value3;
      var type = value4;

       firebase.firestore().collection("Notifications").doc(postid).update({
                accepted: "accepted",
                rejected: "accepted"
                }).then(()=>{

                  if(type == "admin"){
            firebase.firestore().collection("User.Organizations").add(
              {
                username: this.user,
                orgname: orgname,
                role: "admin",
                orgid: orgid
              })
                  }else{

              firebase.firestore().collection("Organizations").doc(orgid).update(
              {
                owner: this.user
              })

                  }


                }).then(()=>{

              const user = firebase.auth().currentUser;

              console.log("user object",user);

                  firebase.firestore().collection("Notifications").where("requesteeEmail", "==", user.email).get().then(snap => {
                let orgs = [];
                snap.forEach(doc => {
                  orgs.push({id: doc.data().orgid,notifid: doc.id,type: doc.data().type,accepted:doc.data().accepted,rejected:doc.data().rejected,requestee:doc.data().requestee,requester:doc.data().requester,requesterEmail:doc.data().requesterEmail,orgname:doc.data().orgname})
                  this.notifications = orgs;
                  console.log(this.notifications);
                })
              })
                

                })

    },
    reject:function(value){
               
      var postid = value;
     
       firebase.firestore().collection("Notifications").doc(postid).update({
                accepted: "rejected",
                rejected: "rejected"
                }).then(()=>{

              const user = firebase.auth().currentUser;

              console.log("user object",user);

                firebase.firestore().collection("Notifications").where("requesteeEmail", "==", user.email).get().then(snap => {
                let orgs = [];
                snap.forEach(doc => {
                  orgs.push({id: doc.data().orgid,notifid: doc.id,type: doc.data().type,accepted:doc.data().accepted,rejected:doc.data().rejected,requestee:doc.data().requestee,requester:doc.data().requester,requesterEmail:doc.data().requesterEmail,orgname:doc.data().orgname})
                  this.notifications = orgs;
                  console.log(this.notifications);
                })
              })
            })

    },
    getOrgs: function(){
          firebase.firestore().collection("User.Organizations").where("username", "==", this.user).get().then(snap => {
      let orgs = [];
      snap.forEach(doc => {
        orgs.push({id: doc.data().orgid,name: doc.data().orgname,role:doc.data().role})
        this.orgArray = orgs;
        console.log("1")
      })
    })
    },
    logout: function(){
            firebase.auth().signOut();
            this.$store.dispatch('logOut');
            this.$router.replace({ name: 'login' });
        }
  },
  computed:{
     user: function(){
       return this.$store.state.user.username;
     },
  },
  mounted:function(){
    //console.log(" user: "+this.user)

     const user = firebase.auth().currentUser;

     console.log(user);
        this.notifications = null;
         firebase.firestore().collection("Notifications").where("requesteeEmail", "==", user.email).get().then(snap => {
      let orgs = [];
      snap.forEach(doc => {
        orgs.push({notifid:doc.id,id: doc.data().orgid,type: doc.data().type,accepted:doc.data().accepted,rejected:doc.data().rejected,requestee:doc.data().requestee,requester:doc.data().requester,requesterEmail:doc.data().requesterEmail,orgname:doc.data().orgname})
        this.notifications = orgs;
        console.log(this.notifications);
      })
    })

    firebase.firestore().collection("User.Organizations").where("username", "==", this.user).onSnapshot(snap => {
      let orgs = [];
      snap.forEach(doc => {
        orgs.push({id: doc.data().orgid,name: doc.data().orgname,role:doc.data().role})
        this.orgArray = orgs;
        console.log("1")
      })
    })

  
    // firebase.firestore().collection("Departmentdata").where("curdept", "==", this.WData.curdept).onSnapshot(snap => {
    //   let deptWs = [];
    //   snap.forEach(doc => {
    //     deptWs.push({id: doc.id,name: doc.data().fullname,curdept:doc.data().curdept})
    //     this.curdeptWorkers = deptWs;
    //      console.log("3")
    //     console.log(deptWs);
    //   })
    // })
  

  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  #app{
    height: 100%;
  }
  html{
    height: 100%;
  }
  body{
    background-color: #f4f4f4;
    width: 100%;
    height: 100%;
  }

  #bcon{
    background-color: #f4f4f4;
    height: 80%;
    position: relative;
    position: relative;
    top: 20%;
  }

  #departmentcols{
    text-align: top;
    background-color: white;
    height: 300px;
    box-shadow: inherit;

  }
  #dstyle{
    font-weight: bold;
  }

  #deptdiv{
    width: 100%;
  }

  #wholedept{
    border: 1px solid #f4f4f4;
    border-radius: 10px;
    background-color: lightgrey;
    position: relative;
    width: 80%;
    padding: 5px;
  }

   #wholedept:hover{
    cursor: pointer;
    background-color: white;
  }

  #deptx{
    color: red;
    border-radius: 50%;
    position: relative;
    top: 20%;
    background-color: white;
    padding: 1px;
  }

  #deptx:hover{
    cursor: pointer;
    background-color: red;
    color: white;
  }

  #orgspan{
    width: 100px;
  }

  #osspan:hover{
    background: grey;
  }

  .active{
    background: grey;
  }
  ul#orgspan{
  list-style-type: none;
  margin: 0;
  padding: 0;
}

ul#orgspan li:hover{
  cursor: pointer;
}

#qrcodeholder{
  width: 50px;
  height: 50px;
  overflow: hidden;
}

#qrcodeholder:hover{
  width: 256px;
  height: 256px;
}
</style>
